<template>
  <div class="">
    <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix">
      <!-- <el-form-item label="货 位：" class="tinp">
        <el-input v-model="conditions.input1" placeholder="请输入调入货位" suffix-icon="el-icon-search" clearable @change="onParamChange('input1', $event)"></el-input>
      </el-form-item> -->
      <el-form-item label="货 位：" class="tinp" style=" margin-right: 20 !important">
        <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
          <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品编码：" class="tinp">
        <el-input v-model="conditions.input3" placeholder="请输入商品编码" suffix-icon="el-icon-search" clearable @change="onParamChange('input3', $event)"></el-input>
      </el-form-item>
      <el-form-item label="商品名称：" class="tinp">
        <el-input v-model="conditions.input2" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable @change="onParamChange('input2', $event)"></el-input>
      </el-form-item>
      <!-- <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div> -->
      <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChanges"  v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
     <!--  <el-button type="primary" class="fr" size="small" icon="el-icon-printer" @click="print" style="margin:0 10px 10px">打印结存表单</el-button>
      <el-button type="primary" class="fr" size="small" icon="el-icon-printer" @click="exportPresentSock" style="margin:0 10px 10px">导出</el-button> --> 
    </el-form>
     <section ref="printtable">
    <div class="tablebox kucun tableboxprint">
      <table style="width:100%">
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style="" v-for="head in tableHeads">{{ head.label }}</th>
          <!-- <th>操作</th> -->
        </tr>
        <tr v-for="(item,index) in tableList" :key="index">
          <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
            <span>{{item[head.key]}}</span>
          </td>
          <!--  item.materialcode<td style="border: 1px solid #56B8AA; height: 38px;width:8%">
                            <el-button type="danger" class="" size="mini" @click="dellist(index,item.clocationid,item.materialcode)">删除</el-button>
                    </td> -->
        </tr>
        <tr v-if="count==0">
          <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
        </tr>
      </table>
    </div>
     </section>
    <!-- fenye start -->
    <div class="block" style="text-align: center;margin:20px auto ">
      <span><el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="count"></el-pagination></span>
    </div>
    <!-- fenye end -->
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<script> 
import { getElementsByClassName } from '../../../static/js/getDomByClassName.js'  
export default {
  name: '',
  data() {
    return {
      flag:false, 
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      width: 0, //动态宽度
      page: 1,
      pageSize: 10,
      count: 0,
      conditions: {
        input1: '', //货位
        input2: '', //关键字
        input3: '', //关键字
      },
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      fullscreenLoading: false,
      userInfo: {},
      tableHeads: [{
          label: '货位',
          key: 'rackname'
        },
        {
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        {
          label: '结存主数量',
          key: 'nonhandnum'
        },
        // {
        //   label: '预留主数量',
        //   key: 'nrsnum'
        // },
        // {
        //   label: '冻结主数量',
        //   key: 'nlocknum'
        // },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        // {
        //   label: '批次号',
        //   key: 'vbatchcode'
        // }
      ],
      tableList: [],
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pageSize");
    sessionStorage.removeItem("kucunlist");
    sessionStorage.removeItem("clocationid");
    sessionStorage.removeItem("Keyword");
    sessionStorage.removeItem("count");
    //console.log("清除session");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) {

      this.modelFlag = false;
      
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
         
      }
    },
     print2() { 
        this.$print(this.$refs.printtable) // 使用
    },
    print() { //连接打印方法 
      sessionStorage.setItem("kucunlist", JSON.stringify(this.tableList));
      // this.obj.flag = false;
      // console.log(this.obj.flag);
      // this.$set(this.obj, 'flag', false);
      // console.log(this.obj.flag);
      // this.$forceUpdate();
      // var positionname = this.cloid;
      // 1.保存原始html并设置要打印的区域
      var oldstr = document.body.innerHTML;
      var newstr = document.getElementsByClassName('tableboxprint')[0].innerHTML;
      // 2. 复制给body，并执行window.print打印功能
      document.body.innerHTML = newstr;
      // 3.打印
      window.print();
      // 4.重新加载页面，以刷新数据
      document.body.innerHTML = oldstr;
      // this.$router.push({ path: '/ui/stock/kong'}); 
      window.location.reload();
    },
    // formatJson(filterVal, jsonData) {
    //   return jsonData.map(v => filterVal.map(j => v[j]))
    // },
    exportPresentSock() {
        require.ensure([], () => {
          const { export_json_to_excel } = require('../../vendor/Export2Excel');
          const tHeader = ['货位', '商品编码', '商品名称', '主单位', '结存主数量', '预留主数量', '冻结主数量', '规格', '型号', ];
          const filterVal = ['rackname', 'materialcode', 'materialname', 'cunitname', 'nonhandnum', 'nrsnum', 'nlocknum', 'wlspec', 'wltype'];
          const list = this.tableList;
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, '结存表单列表');
        })
    },
    export2Excel() {
          var that = this;
          require.ensure([], () => {
              const { export_json_to_excel } = require('../../vendor/Export2Excel'); //这里必须使用绝对路径
              const tHeader =  ['货位', '商品编码', '商品名称', '主单位', '结存主数量', '规格', '型号']; // 导出的表头名
              const filterVal = ['rackname', 'materialcode', 'materialname', 'cunitname', 'nonhandnum',  'wlspec', 'wltype']; // 导出的表头字段名
              const list = that.tableList;
              const data = that.formatJson(filterVal, list);
              let time1,time2 = '';
              if(this.start !== '') {
                  time1 = that.moment(that.start).format('YYYY-MM-DD')
              }
              if(this.end !== '') {
                  time2 = that.moment(that.end).format('YYYY-MM-DD')
              }
              export_json_to_excel(tHeader, data, `[${time1}-${time2}]结存表单excel`);// 导出的表格名称，根据需要自己命名
          })
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    exportPresentSock2() {
      // this.fullscreenLoading = true;
      //搜索参数
      var reqparam = {
        storecode: this.userInfo.storecode, //门店编码 
        positionname: this.conditions.input1, //货位
        productName: this.conditions.input2, //商品名称
      };
      this.$http.post(this.utilpath + '/exportPresentSock', reqparam, { emulateJSON: true,_timeout:600 })
        // this.$http.post("/ktnapi/exportPresentSock",reqparam,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+"/exportPresentSock",reqparam,{emulateJSON:true})
        .then((res) => {
          this.$router.push({ path: '/ui' });  
        }, (err) => {
          this.fullscreenLoading = false;
          console.log(err);
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = "连接导出数据接口失败：" + err;
          this.butflag =false;
          this.butmsg='知道了'; 
        });
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.userInfo.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          //console.log("打印货位" + JSON.stringify(this.positionList));
          // this.getlist();
        }else if(res.data.status == '-1'){
            this.positionList = [];
            this.$message({
              showClose:true,
              message:'暂无数据！',
              type:'info'
            })
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        } 
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    selectchange(value) {
      this.page=1;
      // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      // console.log("下拉变化事件2" + value.positioncode);
      this.position.positioncode = value.positioncode;
      this.position.positionname = value.positionname;
      // this.getlist();
    },
    dellist(index, msg1, msg2) {
      this.$confirm('此操作将永久删除该调整单，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var reqparam = {
          storecode: this.userInfo.storecode, //门店编码
          coutstockorgid: this.userInfo.coutstockorgid, //仓库编码
          clocationid: msg1,
          materialcode: msg2
        };
        this.$http.post(this.utilpath + '/applybill', reqparam).then((res) => {
          // this.$http.post('api/applybill',reqparam).then((res)=>{
          // this.$http.post('ktnapi/applybill',reqparam,{emulateJSON:true}).then((res)=>{
          if (res.data.status == '0') {
            if (this.tableList.length > 1) {
              this.tableList.splice(index, 1);
            }
            this.count = this.tableList.length;
            sessionStorage.setItem("kucunlist", JSON.stringify(this.conditions));
            sessionStorage.setItem("count", this.count);
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'succcess'
            });
          } else if (res.data.status == '-1') {

          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
          }  else {
            this.$message({
              showClose: true,
              message: '删除失败!',
              type: 'error'
            });
          }
        }, (err) => {
          this.$message({
            showClose: true,
            message: '命令提交失败!',
            type: 'error'
          });
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    init() {
      var users = JSON.parse(window.localStorage.getItem("userInfo"));
      if (users != null) {
        this.userInfo = users;
      }
      this.width = document.documentElement.clientWidth - 200; 
      var inp1 = sessionStorage.getItem("clocationid");
      var inp2 = sessionStorage.getItem("Keyword");
      if (inp1 != null) {
        this.conditions.input1 = inp1;
      }
      if (inp2 != null) {
        this.conditions.input2 = inp2;
      } 
      this.getposition();
      // this.getlist(); 
      this.page = parseFloat(sessionStorage.getItem("page"));
      // this.pageSize = parseFloat(sessionStorage.getItem("pageSize")); 
      this.count = this.tableList.length;
      //console.log("2"); 
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.page=1; 
      this.getlist();
     // console.log(this.pageSize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val;
     // console.log("当前页---:" + this.page);
      //console.log("页码----:" + this.pageSize);
      this.getlist();
    },
    getlist() { //获取数据
      this.fullscreenLoading = true;
      //搜索参数 
      var reqparam = {
        storecode: this.userInfo.storecode, //门店编码 
        positioncode: this.position.positioncode==undefined?'':this.position.positioncode, //货位
        positionname: this.position.positionname==undefined?'':this.position.positionname, //货位
        productCode: this.conditions.input3, //商品编码
        productName: this.conditions.input2, //商品名称
        pageNum: this.page,
        pageSize: 10,
      };
      //console.log("reqpara-=-==m" + JSON.stringify(reqparam))
      this.$http.post(this.utilpath + '/PresentSock', reqparam, { emulateJSON: true,_timeout:600 })
        // this.$http.post("/ktnapi/selectPresentSock",reqparam,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true}) 
        .then((res) => {
          if(res.data.status=='0'){ 
              this.fullscreenLoading = false; 
              this.tableList = res.data.resultList;  
              this.count = res.data.countNum;
              //console.log("打印数据长度：" + this.count);
          }else if(res.data.status=='-1'){
              this.fullscreenLoading = false; 
              this.tableList =[];
              this.count =0;
              this.$message({
                  showClose:true,
                  message:'暂无数据！',
                  type:'info'
              })
          } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
          } else{
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了'; 
          }
        }, (err) => {
          this.fullscreenLoading = false;
          this.msgShow =false;
            this.modelFlag = true;
            this.methodName = 'message';
            this.msg = '连接获取现存量接口失败'+err;
            this.butflag =false;
            this.butmsg='知道了';
        });
      sessionStorage.setItem("clocationid", this.conditions.input1);
      sessionStorage.setItem("Keyword", this.conditions.input2);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pageSize", this.pageSize);
      sessionStorage.setItem("count", this.count);
    },
     onParamChanges() { 
      this.page=1;
      this.getlist();
      // }
    }, 
    onParamChange(attr, val) { //搜索变更事件
      this.page=1;
      this.conditions[attr] = val;
      //console.log(this.conditions[attr]);
      // if (this.conditions[attr].trim() != '') {

      // this.getlist();
      // }
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/kucun.vue